function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ee4443",
    d: "M 799.5,560.5 C 799.5,571.5 799.5,582.5 799.5,593.5C 791.371,610.962 778.371,615.795 760.5,608C 752.821,602.476 748.988,594.976 749,585.5C 746.731,485.835 710.231,401.335 639.5,332C 543.812,247.161 433.479,219.494 308.5,249C 185.102,286.064 103.602,365.898 64,488.5C 54.4982,522.846 49.4982,557.846 49,593.5C 41.0777,611.032 28.2443,615.865 10.5,608C 4.95706,603.989 1.29039,598.823 -0.5,592.5C -0.5,581.833 -0.5,571.167 -0.5,560.5C 12.1918,423.424 76.1918,317.924 191.5,244C 305.112,178.824 423.446,168.824 546.5,214C 629.629,247.46 694.796,302.294 742,378.5C 775.169,434.837 794.336,495.504 799.5,560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9b307",
    d: "M 376.5,286.5 C 486.239,281.874 574.739,322.54 642,408.5C 682.485,464.626 701.152,527.292 698,596.5C 689.04,611.536 676.54,615.369 660.5,608C 652.821,602.476 648.988,594.976 649,585.5C 645.59,491.8 604.423,420.3 525.5,371C 441.5,325 357.5,325 273.5,371C 201.516,415.405 160.683,479.905 151,564.5C 150.745,574.199 150.078,583.865 149,593.5C 141.078,611.032 128.244,615.865 110.5,608C 100.895,600.287 97.2287,590.287 99.5,578C 104.909,476.157 148.909,395.823 231.5,337C 275.641,308.05 323.974,291.217 376.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#22c55d",
    d: "M 380.5,386.5 C 465.028,382.673 529.528,416.34 574,487.5C 593.237,521.44 601.237,557.774 598,596.5C 589.04,611.536 576.54,615.369 560.5,608C 554.972,604.151 551.472,598.984 550,592.5C 549.215,537.42 526.715,493.92 482.5,462C 431.559,431.065 379.559,429.065 326.5,456C 275.466,487.198 249.633,533.031 249,593.5C 241.078,611.032 228.244,615.865 210.5,608C 204.972,604.151 201.472,598.984 200,592.5C 199.589,513.132 233.089,452.965 300.5,412C 325.532,397.963 352.198,389.463 380.5,386.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b81f6",
    d: "M 386.5,486.5 C 434.184,483.084 469.018,502.418 491,544.5C 497.886,560.147 500.552,576.48 499,593.5C 491.078,611.032 478.244,615.865 460.5,608C 456.578,604.749 453.412,600.916 451,596.5C 451.311,577.162 444.477,560.995 430.5,548C 414.843,536.758 397.843,534.425 379.5,541C 367.193,547.306 358.359,556.806 353,569.5C 351.137,578.46 349.47,587.46 348,596.5C 339.04,611.536 326.54,615.369 310.5,608C 301.924,601.846 298.257,593.513 299.5,583C 302.483,540.361 323.483,510.361 362.5,493C 370.459,490.179 378.459,488.013 386.5,486.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.5b8fe7c80092c6b223fd87515032763b.svg";
export { ForwardRef as ReactComponent };